'use client';

import type { PropsWithChildren } from 'react';
import { createContext, useMemo } from 'react';
import config from '@packages/config/src';
import type { Config } from '@packages/config/src';
import type { AppName } from '../../utils/types';

export type ConfigProviderProps = {
  config?: Config;
  appName?: AppName;
};

export type ConfigContextT = {
  config: Config;
  appName?: AppName;
};

export const ConfigContext = createContext<ConfigContextT>({ config });

export const ConfigProvider = ({
  config: newConfig,
  appName,
  children,
}: PropsWithChildren<ConfigProviderProps>) => {
  const providerConfig = useMemo(
    () => ({
      config: newConfig || config,
      appName,
    }),
    [newConfig, appName],
  );

  return <ConfigContext.Provider value={providerConfig}>{children}</ConfigContext.Provider>;
};
